import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Card, CardHeader, CardContent, Button } from '@material-ui/core';
import { CaretRightIcon } from 'sharedComponents/Icons';

export const WidgetAction = ({ action, classes }) => {
  const { title, component } = action || {};

  if (title && component) {
    return (
      <Button
        classes={{ root: classes.widgetActionButton, label: classes.widgetActionIcon }}
        endIcon={<CaretRightIcon />}
        component={component}
      >
        {title}
      </Button>
    );
  }

  if (title) {
    return (
      <Button
        classes={{ root: classes.widgetActionButton, label: classes.widgetActionIcon }}
        endIcon={<CaretRightIcon />}
      >
        {title}
      </Button>
    );
  }

  if (typeof component === 'function') return component();

  return null;
};

const Widget = ({
  children,
  classes,
  headerTitle,
  action,
  onClick,
  onHeaderClick,
  isHeaderWithoutBorder,
  isButton,
}) => {
  const titleProps = {
    color: 'inherit',
    variant: 'h2',
    classes: { root: classes.headerTitle },
  };

  const actionProps = {
    action,
    classes,
  };

  return (
    <Card
      className={cx(classes.card, isHeaderWithoutBorder && classes.homePageWidget)}
      elevation={0}
      onClick={onClick}
      data-testid="card-container"
    >
      {headerTitle && (
        <CardHeader
          title={headerTitle}
          action={action && <WidgetAction {...actionProps} />}
          onClick={onHeaderClick}
          classes={{
            root: cx(isHeaderWithoutBorder && classes.homePageWidgetHeader),
            action: classes.headerLink,
          }}
          titleTypographyProps={titleProps}
        />
      )}
      <CardContent className={cx(isButton && classes.isButton)}>{children}</CardContent>
    </Card>
  );
};

Widget.defaultProps = {
  classes: {},
  isHeaderWithoutBorder: false,
  isButton: false,
};

Widget.propTypes = {
  classes: PropTypes.shape({}),
  headerTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  action: PropTypes.shape({
    title: PropTypes.string,
    component: PropTypes.oneOfType([PropTypes.node, PropTypes.elementType]),
  }),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element]).isRequired,
  onClick: PropTypes.func,
  onHeaderClick: PropTypes.func,
  isHeaderWithoutBorder: PropTypes.bool,
  isButton: PropTypes.bool,
};

export default Widget;
